let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8IRQB")).then(() => parcelRequire('5PoQ4'));